import { render, staticRenderFns } from "./TemplateColumnText.vue?vue&type=template&id=cd440d32&"
import script from "./TemplateColumnText.vue?vue&type=script&lang=js&"
export * from "./TemplateColumnText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd440d32')) {
      api.createRecord('cd440d32', component.options)
    } else {
      api.reload('cd440d32', component.options)
    }
    module.hot.accept("./TemplateColumnText.vue?vue&type=template&id=cd440d32&", function () {
      api.rerender('cd440d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/ColumnContent/TemplateColumnText.vue"
export default component.exports